export default "__VITE_ASSET__w2tGxTcO__"